import React from 'react';
import Head from 'next/head';
import BaseLayout from 'layouts/BaseLayout';
import Header from 'components/Benefits/Header';
import MainContent from 'components/Benefits/MainContent';

export default function Benefits() {
  return (
    <BaseLayout hero={<Header />} hasPadding={false}>
      <Head>
        <title>Access powerful Mind the Graph features to make science figures</title>

        <meta
          key="description"
          name="description"
          content="Access powerful Mindthegraph features to make science figures, posters and infographics. Explore benefits and pricing of Mindthegraph."
        />
      </Head>

      <MainContent />
    </BaseLayout>
  );
}
